import { active, link, menu_wrapper } from 'Styles/modules/content-page.module.scss';

import Link from 'next/link';
import classNames from 'classnames';
import { useRouter } from 'next/router';

const ContentMenu = props => {
  const { className, menuItems : data, menuTitle } = props;
  const router = useRouter()

  return (
    <aside className={classNames(menu_wrapper, className)}>
      <h3>{menuTitle || "Danh mục"}</h3>
      <ul>
        {data &&
          data.map((elem) => (
            <li className={classNames(link, router.query.id === elem.slug ? active : '')} key={elem.id}>
              <Link href={elem.path}>
                <a>{elem.name}</a>
              </Link>
            </li>
          ))}
      </ul>
    </aside>
  );
};

export default ContentMenu;
